import { render, staticRenderFns } from "./IconClose03.vue?vue&type=template&id=44df11a4"
import script from "./IconClose03.vue?vue&type=script&lang=ts"
export * from "./IconClose03.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports